import { List } from "@mui/material";

export const UnorderedList = ({ children }) => (
    <List sx={{ listStyleType: "disc", paddingLeft: 3 }}>
        {children}
    </List>
);
